<template>
  <div class="widget-card">
    <v-card class="widget-card__card" height="100%">
      <v-card-title
        class="primary white--text widget-card__card-title"
      >Личные данные
      </v-card-title>
      <v-card-text
        class="widget-card__card-text pt-3"
      >
        <div class="mb-2">{{user.last_name}} {{user.first_name}} {{user.middle_name}}</div>
        <div class="mb-2">{{user.phone_mobile}}</div>
        <div>{{user.email}}</div>
      </v-card-text>
      <v-card-actions
        class="pa-3 widget-card__card-actions"
      >
        <v-btn block color="default" to="/profile" class="widget-card__actions-btn">
          <v-icon>mdi-account-edit</v-icon>
          <span class="pl-4">Изменить</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default { props: ['user'] };
</script>

<style lang="scss"></style>
